import React, { useState } from 'react';

import type { EFakturaGivenPermission } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { validateUser as validateUserData } from '../../../services/eFakturaService';
import useFormContext from '../form/useFormContext';
import { EFakturaError, validateUser } from '../form/validate';

export default (
    currentUserInGiven: EFakturaGivenPermission | undefined,
    setLocalErrors: React.Dispatch<React.SetStateAction<Partial<EFakturaError> | undefined>>,
) => {
    const translated = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const {
        form: { state },
    } = useFormContext();

    const validate = async () => {
        const errors = validateUser(translated, state);
        setLocalErrors(errors);
        const isValid = !(errors.ssn || errors.name || errors.amountSelected);
        if (
            !!currentUserInGiven &&
            (!currentUserInGiven.selectedIssuers || currentUserInGiven.selectedIssuers.length === 0)
        ) {
            setLocalErrors((prev) => ({
                ...prev,
                amountSelected: translated.eFakturaSharing.validationErrors.amountSelected.alreadySharedEverything,
            }));
            return false;
        }
        if (isValid) {
            setIsLoading(true);
            try {
                const validationResult = await validateUserData({
                    customerName: state.name ?? '',
                    customerNumber: {
                        value: state.ssn ?? '',
                    },
                });
                setLocalErrors((prev) => ({
                    ...prev,
                    name:
                        validationResult.status === 'OK'
                            ? undefined
                            : translated.eFakturaSharing.validationErrors.name.error[validationResult.status],
                }));
                setIsLoading(false);
                return validationResult.status === 'OK';
            } catch {
                setLocalErrors((prev) => ({
                    ...prev,
                    name: translated.eFakturaSharing.validationErrors.name.error.ERROR_OCCURED,
                }));
                setIsLoading(false);
                return false;
            }
        }
        return isValid;
    };

    return { validate, isLoading };
};
